const HostEnum = {
  PAY: "pay.prostotv.com",
  SPEED: "speed.prostotv.com",
  // PAY: "pay.local",
  // SPEED: "speed.local"
}

export default HostEnum
